import DOMPurify from 'dompurify';

export function composerSanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_ATTR: ['class'],
  });
}
